module.exports = __webpack_public_path__ + "static/tiktok-dde3256ee575bee8428a3fec4159cef2.png";